import React, { useState } from 'react';

const faqs = [
  { question: 'How do I sign up?', answer: "It's fast and free. Register with your mobile number or Google account, create a team profile, and you're ready to start scoring." },
  { question: 'Is CricFight really free?', answer: 'Yes, 100%. Every feature is free — unlimited live scoring, tournament management, and player stats, with no hidden costs or ads.' },
  { question: 'How does live scoring work?', answer: 'The designated scorer updates the match from their phone. Record runs, wickets, and extras with just a few taps for each ball.' },
  { question: 'How do I challenge local teams?', answer: 'Use our Challenge System — search for teams in your city, check their profiles, and send a match invitation directly through the app.' },
  { question: 'How are my player stats tracked?', answer: 'Every player gets a personal profile. As you play and score matches, your stats like runs, wickets, and averages update automatically.' },
  { question: 'Can I play for multiple teams?', answer: 'Absolutely. Join and play for multiple teams — all your stats are consolidated into your single, overall player profile.' },
  { question: 'What are XP & leaderboards?', answer: "You earn XP for every run you score and wicket you take. Higher XP helps you climb your city's leaderboard and proves you're one of the top players around." },
];

const LandingFAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="cf-section cf-section--alt">
      <div className="cf-container cf-rel-z">
        <div className="cf-section-head cf-reveal">
          <span className="cf-eyebrow">FAQ</span>
          <h2 className="cf-h2">
            Got
            <br />
            <span className="cf-text-gradient">questions?</span>
          </h2>
          <span className="cf-sub">Here are some quick answers.</span>
        </div>

        <div className="cf-faq__list">
          {faqs.map((faq, index) => (
            // Reveal lives on this static wrapper, NOT the button. The button's
            // className toggles with state; if `cf-reveal` were on it, a re-render
            // would wipe the imperatively-added `is-in` and the item would vanish.
            <div
              key={index}
              className="cf-reveal"
              style={{ '--cf-d': `${Math.min(index, 5) * 0.04}s` }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className={`cf-faq__item${openIndex === index ? ' is-open' : ''}`}
              >
                <div className="cf-faq__head">
                  <h3 className="cf-faq__q">{faq.question}</h3>
                  <div className="cf-faq__icon">
                    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M12 5v14M5 12h14" />
                    </svg>
                  </div>
                </div>
                <div className="cf-faq__answer">
                  <div>
                    <p>{faq.answer}</p>
                  </div>
                </div>
              </button>
            </div>
          ))}
        </div>

        <div className="cf-faq__contact">
          <p>Still have questions?</p>
          <a href="mailto:admin@cricfight.in" className="cf-faq__contact-link">
            Contact our support team
            <svg className="cf-icon-sm" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default LandingFAQ;
